import { DispatchType } from "@bridgesplit/react";

/** Label structure for filter buttons */
export type PluralLabelText = {
    all: string;
    single: string;
    multi: string;
};

/** Filter types available */
export enum FilterType {
    Boolean = "Boolean",
    MultiSelect = "MultiSelect"
}

/** Base return types per filter type */
export type FilterReturnType = {
    [FilterType.Boolean]: boolean;
    [FilterType.MultiSelect]: Set<string>;
};

/** Config maps filter keys to their filter type */
export type FilterConfig = {
    [filterKey: string]: keyof FilterReturnType;
};

export type FilterState<C extends FilterConfig> = {
    [K in keyof C]: {
        enabled: boolean;
        condition: FilterReturnType[C[K]];
    };
};

/** Props shared across filter components */
export type FilterProps<C extends FilterConfig> = {
    filters: FilterState<C>;
    defaultState: FilterState<C>;
    setFilters: DispatchType<FilterState<C>>;
};
